import { Translation } from "../model/Translation";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export const deleteTranslation = async (translationId: number): Promise<Translation | null> => {
  const response = await axiosInstance.delete<ApiResponse<Translation>>(`/api/translation/delete/${translationId}`);
  return response.data.data;
};
